// @flow
import React, { useState, useEffect, useRef } from 'react';
import ContentEditable from '../ContentEditable';

export const selectAll = (element) => {
    if (window.getSelection && document.createRange) {
        const range = document.createRange();
        range.selectNodeContents(element);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    }
};

type Props = $ReadOnly<{
    value?: string,
    disabled?: boolean,
    min?: number,
    max?: number,

    onFocus: (e: SyntheticFocusEvent) => void,
    onBlur: (e: SyntheticEvent) => void,
    onChange: (value: number, e: SyntheticEvent) => void,
    onEnter: (e: SyntheticKeyboardEvent) => void
}>;

function PartialInput({ value, disabled, min = 0, max, onFocus, onBlur, onChange, onEnter }: Props) {
    const inputRef = useRef();
    const [innerValue, setInnerValue] = useState(value);

    const handleKeyDown = (e) => {
        if(e.keyCode === 13){
            e.preventDefault();
            onEnter(e);
        }
    };

    const handleFocus = (e) => {
        if(onFocus) {
            onFocus(e);
        }
        setTimeout(() => selectAll(inputRef.current));
    };

    const handleChange = (e) => {
        setInnerValue(e.target.value);

        if(onChange) {
            let value = parseInt(e.target.value, 10);

            if(isNaN(value) || (typeof min !== 'undefined' && value < min)) {
                value = min;
            }
            else if(typeof max !== 'undefined' && value > max) {
                value = max;
            }

            onChange(value, e);
        }
    };

    useEffect(() => {
        if(value !== innerValue) {
            setInnerValue(value);
        }
    }, [value, innerValue]);

    return (
        <ContentEditable
            ref={inputRef}
            value={innerValue}
            disabled={disabled}
            Component="span"
            onFocus={handleFocus}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
        />
    )
}

export default PartialInput;